import { Navigate, useLocation, useSearchParams } from "react-router-dom";

import { useAppSelector } from "store/store";
import { getDecodedToken, getTokenFromStorage } from "utils";

const pathOnlyAdminCanAccess = ["/bo/users"];
const pathOnlyUsersCantAccess = ["/bo/topics", "/bo/sources", "/bo/reports"];

export const ProtectedRoute = ({ logged, children }: any) => {
  /* const profile = useAppSelector((state) => state.profiloSlice); */
  const registerEmail = useAppSelector(
    (state) => state.registerFormSlice.value.email
  );
  const registerEmailResetPassword = useAppSelector(
    (state) => state.resetPasswordFormSlice.value.email
  );
  const activationToken = useAppSelector((state) => state.tokenSlice.token);

  const navigate = useLocation();
  const [searchParams] = useSearchParams();
  let token = getTokenFromStorage();

  if (logged) {
    if (!token) {
      if (
        navigate.pathname === "/bo/check-project-share-code" &&
        searchParams.get("code")?.length &&
        searchParams.get("projectId")?.length
      ) {
        return (
          <Navigate
            to={`/?code=${searchParams.get(
              "code"
            )}&projectId=${searchParams.get("projectId")}`}
            replace={true}
          />
        );
      }
      return <Navigate to="/" replace={true} />;
    }

    let decodedToken = getDecodedToken();
    const profileRole = decodedToken?.role;

    if (profileRole === "USER" || profileRole === "EDITOR") {
      if (pathOnlyAdminCanAccess.includes(navigate.pathname)) {
        return <Navigate to="/bo" replace={true} />;
      }
    }
    if (profileRole === "USER") {
      if (pathOnlyUsersCantAccess.includes(navigate.pathname)) {
        return <Navigate to="/bo" replace={true} />;
      }
    }
  } else {
    if (token) {
      return <Navigate to="/bo" replace={true} />;
    }

    if (navigate.pathname === "/verify-email" && !registerEmail.length) {
      return <Navigate to="register" replace={true} />;
    }
    if (navigate.pathname === "/set-password" && !activationToken.length) {
      return <Navigate to="/" replace={true} />;
    }
    if (
      navigate.pathname === "/verify-email-reset-password" &&
      !registerEmailResetPassword.length
    ) {
      return <Navigate to="reset-password" replace={true} />;
    }
  }

  return children;
};
